import Companies from '../../api/companies'

export default {
  namespaced: true,
  state: {
    companies: [],
    requestedCompanies: [],
    activeCompanies: [],
    actionLoading: false,
    modalActive: false,
    indicator: '',
    companiesLoading: false,
    requestedCompaniesLoading: false,
    activeCompaniesLoading: false,
    jobBoardIdForAdminCom: null
  },
  mutations: {
    setJobBoardIfForAdminCom (state, id) {
      state.jobBoardIdForAdminCom = id
    },
    setCompanies (state, companies) {
      state.companies = companies
    },
    addCompany (state, company) {
      state.companies.push(company)
    },
    updateCompany (state, company) {
      const index = state.companies.findIndex(c => c.id === company.id)
      if (index === -1) { return state.companies.push(company) }
      state.companies[index] = company
    },
    setRequestedCompanies (state, requestedCompanies) {
      state.requestedCompanies = requestedCompanies
    },
    setActionLoading (state, actionLoading) {
      state.actionLoading = actionLoading
    },
    setModalActive (state, modalActive) {
      state.modalActive = modalActive
    },
    setIndicator (state, indicator) {
      state.indicator = indicator
    },
    setActiveCompanies (state, activeCompanies) {
      state.activeCompanies = activeCompanies
    },
    setCompaniesLoading (state, companiesLoading) {
      state.companiesLoading = companiesLoading
    },
    setRequestedCompaniesLoading (state, requestedCompaniesLoading) {
      state.requestedCompaniesLoading = requestedCompaniesLoading
    },
    setActiveCompaniesLoading (state, activeCompaniesLoading) {
      state.activeCompaniesLoading = activeCompaniesLoading
    },
    setUpdateActiveCompanyToggleStatus (state, { value, id }) {
      const updateActiveCompanies = state.activeCompanies.map(company => {
        if (company.id === id) {
          return {
            ...company,
            status: value
          }
        }
        return {...company}
      })
      state.activeCompanies = updateActiveCompanies
    }
  },
  actions: {
    async getAll ({ commit }) {
      commit('setCompaniesLoading', true)
      const companies = await Companies.all()
      commit('setCompanies', companies)
      commit('setCompaniesLoading', false)
    },
    async getRequestedCompanies ({commit}) {
    },
    async getAllCompanies ({commit}, id) {
      commit('setRequestedCompaniesLoading', true)
      commit('setActiveCompaniesLoading', true)

      const activeCompanies = await Companies.getActiveCompanies(id)
      const requestedCompanies = await Companies.getRequestedCompanies(id)

      commit('setActiveCompanies', activeCompanies.data)
      commit('setRequestedCompanies', requestedCompanies.data)

      commit('setRequestedCompaniesLoading', false)
      commit('setActiveCompaniesLoading', false)
    },
    async companyAction ({commit, state, dispatch}, data) {
      try {
        commit('setActionLoading', true)
        await Companies.companyAction(data, state.indicator)
        commit('setActionLoading', false)
        commit('setModalActive', false)
        dispatch('getAllCompanies', state.jobBoardIdForAdminCom)
      } catch (e) {
        commit('setActionLoading', false)
        commit('setModalActive', false)
      }
    },
    async toggleCompany ({commit, state}, {value, data}) {
      try {
        const company = await Companies.toggleCompany({
          companyId: data.id,
          boardId: data.boardId
        })
        commit('setUpdateActiveCompanyToggleStatus', {value: company.status, id: data.id})
      } catch (e) {
        console.log('error', e)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin-companies.js